import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SignDemoComponent} from './sign-demo/sign-demo.component';
import {TableComponent} from './table/table.component';
import {MultipleLevelListComponent} from './multiple-level-list/multiple-level-list.component';
import {AuthWithForcedLoginGuard} from '@app/oauth/auth-with-forced-login.guard';
import {RedistributionsTableComponent} from '@app/redistribution/redistributions-table/redistributions-table.component';
import {RedistributionDetailsComponent} from '@app/redistribution/redistribution-details/redistribution-details.component';
import {NotFoundComponent} from '@app/not-found/not-found.component';
import {QuarantineTableComponent} from "@app/quarantine/quarantine-table/quarantine-table.component";
import {QuarantinePlacementFormComponent} from "@app/quarantine/quarantine-placement-form/quarantine-placement-form.component";
import {
  CreateQuarantinePlacementComponent
} from "@app/quarantine/create-quarantine-placement/create-quarantine-placement.component";
import {
  EditQuarantinePlacementComponent
} from "@app/quarantine/edit-quarantine-placement/edit-quarantine-placement.component";
import {
  CreateQuarantineRemovalComponent
} from "@app/quarantine/create-quarantine-removal/create-quarantine-removal.component";
import {
  EditQuarantineRemovalComponent
} from "@app/quarantine/edit-quarantine-removal/edit-quarantine-removal.component";
import {QuarantineComponent} from "@app/quarantine/quarantine/quarantine.component";
import {
  CreateRedistributionRequestComponent
} from "@app/redistribution/create-redistribution-request/create-redistribution-request.component";
import {
  RedistributionRequestTableComponent
} from "@app/redistribution/redistribution-request-table/redistribution-request-table.component";
import {
  RedistributionRequestDetailsComponent
} from "@app/redistribution/redistribution-request-details/redistribution-request-details.component";
import {OnlyMozDozGuard} from "@app/oauth/only-moz-doz.guard";
import {ForbiddenComponent} from "@app/forbidden/forbidden.component";
import {OnlyMozDozViewerGuard} from "@app/oauth/only-moz-doz-viewer.guard";

const routes: Routes = [
  {
    path: '',
    component: TableComponent,
    canActivate: [AuthWithForcedLoginGuard],
    outlet: 'table',
    data: {
      breadcrumbs: [{title: 'Реєстр наявних лікарських засобів і медичних виробів', link: ''}]
    }
  },
  {
    path: '',
    component: MultipleLevelListComponent,
    canActivate: [AuthWithForcedLoginGuard],
    outlet: 'list',
    data: {
      breadcrumbs: [{title: 'Реєстр наявних лікарських засобів і медичних виробів', link: ''}]
    }
  },
  {
    path: 'redistributions',
    canActivate: [AuthWithForcedLoginGuard],

    children: [
      {
        path: 'offers',
        component: RedistributionsTableComponent,
        canActivate: [AuthWithForcedLoginGuard],
        data: {
          breadcrumbs: [{title: 'Перерозподіл', link: '/redistributions/offers' }]
        },
      },
      {
        path: 'requests',
        component: RedistributionRequestTableComponent,
        canActivate: [AuthWithForcedLoginGuard, OnlyMozDozGuard],
        data: {
          breadcrumbs: [{title: 'Перерозподіл', link: '/redistributions/requests' }]
        },
      },
      {
        path: 'requests/:id',
        component: RedistributionRequestDetailsComponent,
        canActivate: [AuthWithForcedLoginGuard, OnlyMozDozViewerGuard],
        data: {
          breadcrumbs: [{title: 'Перерозподіл', link: '/redistributions/requests' }]
        },
      },
      {
        path: 'offers/:id',
        component: RedistributionDetailsComponent,
        canActivate: [AuthWithForcedLoginGuard],
        data: {
          breadcrumbs: [{title: 'Перерозподіл', link: '/redistributions'}]
        },
      },
      {
        path: 'create-request',
        component: CreateRedistributionRequestComponent,
        canActivate: [AuthWithForcedLoginGuard, OnlyMozDozViewerGuard],
        data: {
          breadcrumbs: [{title: 'Перерозподіл', link: '/redistributions'}]
        }
      },
      {path: '**', redirectTo: '/redistributions/offers'},
    ]
  },
  {
    path: 'quarantine',
    canActivate: [AuthWithForcedLoginGuard],
    children: [
      {
        path: '',
        component: QuarantineComponent,
        canActivate: [AuthWithForcedLoginGuard],
        data: {
          breadcrumbs: [{title: 'Карантин медичних товарів', link: ''}]
        }
      },
      {
        path: 'create-quarantine-placement',
        component: CreateQuarantinePlacementComponent,
        data: {
          breadcrumbs: [{title: 'Карантин медичних товарів', link: '/quarantine'}]
        }
      },
      {
        path: 'edit-quarantine-placement',
        component: EditQuarantinePlacementComponent,
        data: {
          breadcrumbs: [{title: 'Карантин медичних товарів', link: '/quarantine'}]
        }
      },
      {
        path: 'create-quarantine-removal',
        component: CreateQuarantineRemovalComponent,
        data: {
          breadcrumbs: [{title: 'Карантин медичних товарів', link: '/quarantine'}]
        }
      },
      {
        path: 'edit-quarantine-removal',
        component: EditQuarantineRemovalComponent,
        data: {
          breadcrumbs: [{title: 'Карантин медичних товарів', link: '/quarantine'}]
        }
      },
    ]
  },


  {
    path: 'sign-demo',
    component: SignDemoComponent,
    data: {
      breadcrumbs: []
    }
  },
  {path: 'forbidden', component: ForbiddenComponent},
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '/404'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
